module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wMcCjoa1DfzrgAAAHhJREFUWMPtlEsKwCAMBcee2rt4NnHnMWw3CkVs04UWF28gSGQSxB8IIYQQ4hMO8EAESh19nf/Vd0AGzkHkQcFS3z+ILXzXfKkfDTl2zZf4bXvKy1lTC45bvsRvBcm43MnIp/htMcGQg5FP9bd6TVv9M0IIIYQYcAE7S39oLlFlewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/more_dots_inverted.png
// module id = 516
// module chunks = 0